import type { InboxFilter } from '@dnx/contracts';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getRouteApi } from '@tanstack/react-router';
import { MessagesSquare } from 'lucide-react';
import { useEffect, useState } from 'react';
import { meQuery } from '../lib/session.js';
import { ContactPanel } from './contact-panel.js';
import { ConversationList } from './conversation-list.js';
import { ConversationView } from './conversation-view.js';

export interface InboxSearch { filtro?: InboxFilter; c?: string }
const route = getRouteApi('/app/conversas');

/** Relógio compartilhado: tempos de espera ("há 6 min") avançam sem refetch. */
function useNow(ms = 30_000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), ms); return () => clearInterval(t); }, [ms]);
  return now;
}

export function InboxPage() {
  const { filtro = 'waiting', c } = route.useSearch();
  const { data: me } = useSuspenseQuery(meQuery);
  const now = useNow();
  return (
    // ocupa a altura útil do shell (sem o padding do <main>)
    <div className="grid h-full min-h-0 grid-cols-1 border-border md:grid-cols-[344px_minmax(0,1fr)] xl:grid-cols-[344px_minmax(0,1fr)_280px]">
      <aside className={`min-h-0 border-r border-border bg-surface ${c ? 'hidden md:block' : ''}`}>
        <ConversationList filter={filtro} selectedId={c} now={now} />
      </aside>
      <section className={`min-h-0 ${c ? '' : 'hidden md:block'}`}>
        {c ? <ConversationView key={c} id={c} meId={me.user.id} now={now} filter={filtro} /> : (
          <div className="grid h-full place-items-center bg-bg px-6 text-center">
            <div>
              <span className="mx-auto grid size-12 place-items-center rounded-full bg-primary-soft text-primary"><MessagesSquare className="size-6" /></span>
              <p className="mt-3 text-sm font-medium text-fg">Selecione uma conversa</p>
              <p className="mt-1 text-[12.5px] text-fg-muted">Quem espera há mais tempo aparece primeiro em "Aguardando".</p>
              {import.meta.env.DEV && (
                <a href="/dev/whatsapp" target="_blank" rel="noreferrer" className="mt-4 inline-block text-[12.5px] font-medium text-warning underline">
                  Abrir simulador de WhatsApp (dev)
                </a>
              )}
            </div>
          </div>
        )}
      </section>
      <aside className="hidden min-h-0 overflow-y-auto border-l border-border bg-surface xl:block">
        {c && <ContactPanel id={c} now={now} />}
      </aside>
    </div>
  );
}
